<template>
<div class="text-center">
    <v-btn
        class="text-none px-4 rounded-xl ma-2"
        color="#f5f5f5"
        @click="openDialog"
    >
        <slot></slot>
    </v-btn>
    <v-dialog
        v-model="dialog"
        width="unset"
        max-width="500"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        transition="v-expand-y-transition"
    >
        <v-card
            class="elevation-12"
            width="89vw"
            max-width="500px"
        >
            <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Payment Recipient Details</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pa-4">
                <v-form ref="form">
                    <!-- Delivery Method -->
                    <v-expand-transition>
                        <div v-if="deliveryMethods">
                            <v-autocomplete key="delivery methods" v-model="selectedDeliveryMethod" v-validate="'required'" :error-messages="errors.first('delivery method')" aria-required required name="Delivery Method" label="Delivery Method"
                              :items="deliveryMethods" return-object item-text="method" item-color="primary" color="primary" outlined />
                        </div>
                    </v-expand-transition>

                    <!-- Payment Provider -->
                    <v-expand-transition>
                        <div v-if="filteredPaymentProviders">
                            <v-autocomplete key="payment provider" v-model="selectedPaymentProvider" v-validate="'required'" :error-messages="errors.first('payment provider')" aria-required required name="payment provider" label="Payment Provider"
                              :items="filteredPaymentProviders" item-text="name" return-object item-color="primary" color="primary" outlined />
                        </div>
                    </v-expand-transition>

                    <!-- Branch Name -->
                    <v-expand-transition>
                        <div v-if="selectedPaymentProvider" key="branches">
                            <!-- If there are selectable branches... -->
                            <v-expand-transition>
                                <div v-if="(paymentProviderBranches.length > 1) && loading.length === 0">
                                    <v-autocomplete v-model="selectedBranch" name="branch" label="Branch" :items="paymentProviderBranches" item-text="name" return-object item-color="primary" color="primary" outlined />
                                </div>
                            </v-expand-transition>
                        </div>
                    </v-expand-transition>

                    <!-- Account Number -->
                    <v-expand-transition>
                        <div v-if="paymentTypeIsBank">
                            <v-text-field
                                v-model="accountNumber"
                                v-validate="accountNumberRules"
                                name="account number"
                                ref="account_number"
                                aria-required
                                required
                                label="Recipient Account number"
                                color="primary"
                                outlined
                                validate-on-blur
                                :error-messages="errors.first('account number')"
                            />
                        </div>
                    </v-expand-transition>

                    <!-- Confirm Account Number -->
                    <v-expand-transition>
                        <div v-if="paymentTypeIsBank">
                            <v-text-field
                                ref="account-confirmation"
                                v-model="confirmAccountNumber"
                                label="Confirm Recipient Account Number"
                                name="account confirmation"
                                color="primary"
                                outlined
                            />
                        </div>
                    </v-expand-transition>


                    <!-- Phone -->
                    <v-text-field
                        v-if="paymentTypeIsMobile || paymentTypeIsPickup"
                        v-model="phone"
                        v-validate="phoneRules"
                        validate-on-blur
                        name="phone"
                        :aria-required="paymentTypeIsMobile || paymentTypeIsPickup"
                        :required="paymentTypeIsMobile || paymentTypeIsPickup"
                        label="Phone number"
                        color="primary"
                        outlined
                        :error-messages="errors.first('phone')"
                    />

                    <!-- Confirm Phone -->
                    <v-expand-transition>
                        <div v-if="paymentTypeIsMobile || paymentTypeIsPickup">
                            <v-text-field
                                v-model="confirmPhone"
                                v-validate="phoneRules"
                                validate-on-blur
                                name="confirm phone"
                                aria-required
                                required
                                label="Confirm Phone number"
                                color="primary"
                                outlined
                                :error-messages="errors.first('confirm phone')"
                            />
                        </div>
                    </v-expand-transition>

                </v-form>
            </v-card-text>
            <v-card-actions class="pa-6">
                <v-btn class="px-6" color="primary" dark depressed large @click.native="submit">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
    props: {
        countryCode: null,
    },
    data,
    computed: getComputed(),
    watch: {
      loading: function() {
          if (this.loading.length > 0) {
              this.$emit('loading');
          } else {
              this.$emit('loaded');
          }
      },
    },
    methods: getMethods(),
};

function data() {
    return {
        dialog: false,
        selectedDeliveryMethod: {},
        selectedPaymentProvider: null,
        selectedBranch: {},
        selectedBranchCode: null,
        accountNumber: null,
        confirmAccountNumber: null,
        phone: null,
        confirmPhone: null,
        paymentProviders: [],
        deliveryMethods: [],
        branches: [],
        loading: [],
    };
}

function getMethods() {
    return {
        submit,
        loaded,
        openDialog,
    };

    function submit() {
        const vm = this;
        vm.$validator.validateAll().then((isValid) => {
            if (isValid) {
                const account = {};

                account.payment_type = {
                    ...vm.selectedDeliveryMethod
                };
                delete account.payment_type.providers;

                if (vm.selectedPaymentProvider) {
                    account.payment_provider = vm.selectedPaymentProvider;
                }

                if (vm.selectedBranch) {
                    account.branch = vm.selectedBranch;
                }

                account.account_number = vm.accountNumber;
                account.phone = vm.phone;

                this.$emit('onFinished', {
                  account,
                  provider: 'KAOSHI',
                });
            }
        });
    }

    function loaded(type) {
      const index = this.loading.indexOf(type);
      if (index >= 0) {
        this.loading.splice(index, 1);
      }
    }

    function openDialog() {
        const vm = this;
        this.dialog = true;
        getDeliveryMethodProviders();
        getDeliveryMethods();
        getProviderBranches();

        function getDeliveryMethodProviders() {
            vm.loading.push('deliveryMethodProviders');
            Vue.backendApi().deliveryMethods().deliveryMethodProviders({
                country_abbreviation: vm.countryCode
            }).then(success, error);

            function success(response) {
                vm.loaded('deliveryMethodProviders');
                const deliveryMethodProviders = response.data.filter(
                    (provider) => provider.provider.country_abbreviation === vm.countryCode,
                );
                Vue.set(vm, 'paymentProviders', deliveryMethodProviders);
            }

            function error(err) {
                vm.loaded('deliveryMethodProviders');
                vm.$swal({
                    type: 'error',
                    title: 'Error retrieving payment providers',
                    text: err,
                });
            }
        }

        function getDeliveryMethods() {
            vm.loading.push('deliveryMethods');
            Vue.backendApi().deliveryMethods().deliveryMethods().then(success, error);

            function success(response) {
                vm.loaded('deliveryMethods');
                Vue.set(vm, 'deliveryMethods', response.data);
            }

            function error(err) {
                vm.loaded('deliveryMethods');
                vm.$swal({
                    type: 'error',
                    title: 'Error retrieving delivery methods',
                    text: err,
                });
            }
        }

        function getProviderBranches() {
            vm.loading.push('providerBranches');
            Vue.backendApi().deliveryMethods().providerBranches().then(success, error);

            function success(response) {
                vm.loaded('providerBranches');
                Vue.set(vm, 'branches', response.data);
            }

            function error(err) {
                vm.loaded('providerBranches');
                vm.$swal({
                    type: 'error',
                    title: 'Error retrieving branches for the selected payment provider',
                    text: err,
                });
            }
        }
    }
}

function getComputed() {
    return {
        filteredPaymentProviders,
        paymentProviderRules,
        paymentProviderBranches,
        paymentTypeIsBank,
        paymentTypeIsMobile,
        paymentTypeIsPickup,
        phoneRules,
        accountNumberRules,
    };

    function filteredPaymentProviders() {
        const vm = this;
        if (!vm.selectedDeliveryMethod.providers) return [];
        return vm.selectedDeliveryMethod.providers.filter((provider) => provider.country_abbreviation === vm.countryCode);
    }

    function paymentProviderRules() {
        const vm = this;
        if (!vm.selectedPaymentProvider || vm.paymentProviders.length === 0) {
            return {
                name: '',
                email_address: '',
                phone_number: '',
                account_number: '',
            };
        }

        const selectedProvider = vm.paymentProviders.find(
            (provider) => provider.provider_id === vm.selectedPaymentProvider.id,
        );
        if (selectedProvider) {
            return selectedProvider.rules.rules;
        } else {
            return {}
        }
    }

    function paymentProviderBranches() {
        const vm = this;
        if (vm.branches === []) return [];
        const filteredBranches = vm.branches.filter(
            (branch) => branch.provider_id === vm.selectedPaymentProvider.id,
        );
        if (filteredBranches.length === 1) {
            Vue.set(vm, 'selectedBranch', filteredBranches[0]);
        }
        return filteredBranches;
    }

    function paymentTypeIsBank() {
        return this.selectedDeliveryMethod.method === 'bank-transfer';
    }

    function paymentTypeIsMobile() {
        return this.selectedDeliveryMethod.method === 'mobile-money';
    }

    function paymentTypeIsPickup() {
        return this.selectedDeliveryMethod.method === 'pickup';
    }

    function phoneRules() {
        if (this.paymentTypeIsMobile || this.paymentTypeIsPickup) {
            return `required|country-code:${this.countryCode}|international-phone:${this.countryCode}`;
        }
        return `country-code:${this.countryCode}|international-phone:${this.countryCode}`;
    }

    function accountNumberRules() {
        return `${this.paymentProviderRules.account_number}|numeric`;
    }
}
</script>
